<template>
  <section class="event-card-section">
    <div class="event-card-toolbar-container" :class="event.class">
      <i :title="$t('eventCard.edit')" class="event-card-toolbar-item far fa-edit" @click="clickEditHandler" v-if="event.draggable"></i>
      <i :title="$t('eventCard.delete')" class="event-card-toolbar-item far fa-trash-alt" @click="eventDelete({ schedule_id: event.schedule_id })"></i>
      <i :title="$t('eventCard.download')" class="event-card-toolbar-item fas fa-file-download" @click="downloadEvent"></i>
      <i :title="$t('eventCard.close')" class="event-card-toolbar-item fas fa-times" @click="closeCard"></i>
    </div>
    <div class="event-card-row" v-if="isEditing">
      <div class="event-card-color-radio-container">
        <RadioBox label="default" value="default" v-model="event.class" />
        <RadioBox label="typeA" value="typeA" v-model="event.class" />
        <RadioBox label="typeB" value="typeB" v-model="event.class" />
        <RadioBox label="typeC" value="typeC" v-model="event.class" />
      </div>
    </div>
    <div class="event-card-row" v-if="!isEditing">
      <i class="far fa-clock" style="margin-right: 8px"></i>
      <span>{{ dateFormatHandler(event.start) }} - {{ dateFormatHandler(event.end) }}</span>
    </div>
    <div class="event-card-row" style="margin-bottom: 0" v-if="isEditing">
      <label for="inputDateStart" style="width: 80px">
        <i class="far fa-clock" style="margin-right: 8px"></i>
        {{ $t('eventCard.start') }}
      </label>
      <input id="inputDateStart" class="event-card-input" style="max-width: 220px" type="datetime-local" :value="dayjs(event.start).format('YYYY-MM-DDTHH:mm')" @input="event.start = new Date($event.target.value)" />
    </div>
    <div class="event-card-row" style="margin-top: 0" v-if="isEditing">
      <label for="inputDateEnd" style="width: 80px">
        <i class="far fa-clock" style="margin-right: 8px"></i>
        {{ $t('eventCard.end') }}
      </label>
      <input id="inputDateEnd" class="event-card-input" style="max-width: 220px" type="datetime-local" :value="dayjs(event.end).format('YYYY-MM-DDTHH:mm')" @input="event.end = new Date($event.target.value)" />
    </div>
    <!-- TITLE -->
    <div class="event-card-row">
      <i class="far fa-calendar-check"></i>
      <input class="event-card-input" type="text" disabled v-model="event.title" v-if="!isEditing" />
      <input class="event-card-input" type="text" v-model="event.title" v-if="isEditing" />
    </div>
    <!-- DESCRIPTION -->
    <div class="event-card-row">
      <i class="fas fa-bars"></i>
      <textarea class="event-card-input" disabled v-model="event.description" v-if="!isEditing" />
      <textarea class="event-card-input" v-model="event.description" v-if="isEditing" />
    </div>
    <!-- LINK -->
    <div class="event-card-row">
      <i class="fas fa-link"></i>
      <div v-for="link in event.links" :key="link.url">
        <a class="event-card-input" :href="link.url" target="_blank" v-if="!isEditing && link.url && link.url.startsWith('http')">{{ link.url }}</a>
        <button class="button" v-if="!isEditing && link.url && link.url.startsWith('{')">
          <router-link class="event-card-input" :to="JSON.parse(link.url)">{{ $t('eventCard.enter') }}</router-link>
        </button>
        <input class="event-card-input" type="text" v-model="link.url" :placeholder="$t('eventCard.guestPlaceholder')" v-if="isEditing" />
      </div>
    </div>
    <!-- NOTES -->
    <div class="event-card-row" v-if="event.draggable">
      <i class="far fa-clipboard"></i>
      <textarea class="event-card-input" v-model="event.notes" disabled v-if="!isEditing" />
      <textarea class="event-card-input" v-model="event.notes" v-if="isEditing" />
    </div>
    <!-- PUBLIC -->
    <div class="event-card-row">
      <i class="fas fa-user-lock" v-if="!event.public"></i>
      <i class="fas fa-users" v-if="event.public"></i>
      <label v-if="!isEditing">{{ event.public ? $t('eventCard.public') : $t('eventCard.private') }}</label>
      <select class="event-card-input" style="cursor: pointer" v-model="event.public" v-if="isEditing">
        <option :value="true">{{ $t('eventCard.public') }}</option>
        <option :value="false">{{ $t('eventCard.private') }}</option>
      </select>
    </div>
    <!-- ADD GUESTS -->
    <div class="event-card-row">
      <i class="fas fa-user-friends"></i>
      <input class="event-card-input" type="text" v-model="guest.user_id" :placeholder="$t('eventCard.guestPlaceholder')" v-for="guest in event.guests" :key="guest.user_id" />
    </div>
    <div class="event-card-row">
      <label class="event-card-input">{{ $t('eventCard.me') }} {{ $store.state.user.id }}</label>
      <button class="button" @click="event.guests.push({ name: $store.state.user.name, user_id: $store.state.user.id })">{{ $t('eventCard.subscribe') }}</button>
    </div>
    <!-- CONFIRMATION -->
    <!-- <div class="event-card-row" v-if="isEditing">
      <label>Confirmado: </label>
      <select class="event-card-input" style="cursor:pointer" v-model="event.confirm">
        <option :value="true">Sim</option>
        <option :value="false">Não</option>
      </select>
    </div>
    <div class="event-card-row" v-if="isEditing">
      <label>Status: {{event.status}}</label>
    </div> -->
    <div class="event-card-row" style="background: transparent">
      <button class="button" style="margin-left: auto" @click="eventChange({ event: event })" v-if="isEditing">{{ $t('eventCard.save') }}</button>
    </div>
  </section>
</template>

<script>
import * as dayjs from 'dayjs';
import RadioBox from '@/components/general/RadioBox.vue';

export default {
  name: 'EventCard',

  components: {
    RadioBox,
  },
  props: {
    event: Object,
    isEditing: Boolean,
  },

  data() {
    return {
      dayjs: null,
    };
  },
  beforeMount() {
    this.dayjs = dayjs;
  },

  methods: {
    eventChange(data) {
      this.$emit('saved', data);
    },
    eventDelete(e) {
      // console.log('eventDelete', e);
      this.$emit('deleted');
    },
    clickEditHandler() {
      this.$emit('clickEdit');
    },
    closeCard() {
      this.$emit('closeCard');
    },
    dateFormatHandler(date) {
      // console.log(start);
      return this.dayjs(date).format('DD/MMMM/YYYY, ddd, HH:mm');
    },
    downloadEvent() {
      this.$ics.addEvent('pt-br', this.event.title, this.event.content, 'location', this.event.start, this.event.end, 'url', 'organizer');
      this.$ics.download('event');
      this.$ics.removeAllEvents();
    },
  },
};
</script>

<style lang="scss">
.event-card-section {
  display: flex;
  flex-direction: column;
}
.event-card-toolbar-container {
  // background: red;
  position: relative;
  width: 100%;
  padding: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: flex-end;
}
.event-card-toolbar-item {
  margin: 0 10px;
  color: white;
  font-size: 1.1rem;
}
.event-card-color-radio-container {
  position: relative;
  z-index: 1;
  margin-left: auto;
  display: flex;
}
.event-card-row {
  position: relative;
  // background: #ffffff20;
  margin: 10px 0px 6px;
  padding: 6px 20px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
}
.event-card-input {
  position: relative;
  flex-grow: 1;
  width: 100%;
  margin: 0 8px;
  background: transparent;
  border: none;
  color: black;
}
</style>
